(function (scope, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (scope && scope.document) {
    var previous = scope.FASGardenSpace;
    if (previous && previous.dispose) previous.dispose();
    scope.FASGardenSpace = api.createEngine(scope);
  }
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var ROOT = '[data-fas-garden]';
  var NAMES = ['Volver a vosotros', 'A la luz del jardín', 'Vuestro refugio', 'Un lugar para vuestra historia'];
  var BURST_SIZE = 6;
  var MAX_PETALS = 18;
  var PETAL_LIFETIME = 1000;
  var ACTION_COOLDOWN = 280;

  function finite(value, fallback) { return Number.isFinite(Number(value)) ? Number(value) : fallback; }
  function clamp(value, min, max) { return Math.min(max, Math.max(min, finite(value, min))); }
  function sceneIndex(value) { return Math.round(clamp(value, 0, 3)); }
  function scrollRange(height, viewport) { return Math.max(0, finite(height, 0) - Math.max(0, finite(viewport, 0))); }
  function effectiveReduced(system) { return Boolean(system); }

  function gardenState(top, height, viewport, reduced) {
    var range = scrollRange(height, viewport);
    var progress = range > 0 ? clamp(-finite(top, 0) / range, 0, 1) : 0;
    var position = progress * 3;
    var scene = sceneIndex(position);
    return {
      progress: progress,
      scene: scene,
      travel: reduced ? scene : position,
      bloom: reduced ? 1 : clamp(position, 0, 1)
    };
  }

  function sceneScrollTarget(top, height, viewport, scrollY, index) {
    return Math.max(0, finite(top, 0) + finite(scrollY, 0) + scrollRange(height, viewport) * sceneIndex(index) / 3);
  }

  function roomState(travel, index, reduced) {
    var distance = Math.abs(clamp(travel, 0, 3) - sceneIndex(index));
    return {
      opacity: reduced ? (distance === 0 ? 1 : 0) : Math.max(0, 1 - distance),
      scale: 1
    };
  }

  function experienceState() {
    return { x: 0, y: 0, story: 0, light: 0 };
  }

  function createEngine(win) {
    var doc = win.document;
    var html = doc.documentElement;
    var query = win.matchMedia ? win.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var controllers = new Map();
    var bursts = new Set();
    var removers = [];
    var frame = null;
    var disposed = false;
    var petalCount = 0;
    var priorReduced = html.getAttribute('data-fg-reduced');

    function reduced() { return effectiveReduced(query && query.matches); }
    function listen(target, name, callback, settings) {
      target.addEventListener(name, callback, settings);
      removers.push(function () { target.removeEventListener(name, callback, settings); });
    }
    function attribute(element, name, value) {
      if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    }
    function variable(element, name, value) {
      var text = Number(value).toFixed(5);
      if (element.style.getPropertyValue(name) !== text) element.style.setProperty(name, text);
    }
    function cancelFrame() {
      if (frame !== null) win.cancelAnimationFrame(frame);
      frame = null;
    }
    function removeBurst(burst) {
      if (!bursts.delete(burst)) return;
      win.clearTimeout(burst.timer);
      burst.nodes.forEach(function (node) { node.remove(); });
      if (burst.overlay) burst.overlay.remove();
      petalCount -= burst.nodes.length;
    }
    function clearBursts(controller) {
      Array.from(bursts).forEach(function (burst) {
        if (!controller || burst.controller === controller) removeBurst(burst);
      });
    }
    function render(controller) {
      var state = gardenState(controller.root.getBoundingClientRect().top, controller.root.offsetHeight, win.innerHeight, reduced());
      var stage = controller.stage;
      variable(stage, '--fg-progress', state.progress);
      variable(stage, '--fg-travel', state.travel);
      variable(stage, '--fg-bloom', state.bloom);
      var experience = experienceState(state.progress, reduced());
      variable(stage, '--fg-world-x', experience.x);
      variable(stage, '--fg-world-y', experience.y);
      variable(stage, '--fg-story-drift', experience.story);
      variable(stage, '--fg-light-drift', experience.light);
      attribute(stage, 'data-scene', String(state.scene));
      attribute(controller.root, 'data-scene', String(state.scene));
      controller.rooms.forEach(function (room) {
        var number = Number(room.getAttribute('data-fg-room'));
        if (!Number.isInteger(number) || number < 0 || number > 3) return;
        var values = roomState(state.travel, number, reduced());
        variable(room, '--fg-opacity', values.opacity);
        variable(room, '--fg-room-scale', values.scale);
      });
      if (controller.scene !== state.scene) {
        if (controller.scene >= 0 && !reduced() && controller.transition && !doc.querySelector('dialog[open]')) {
          if (controller.transitionTimer) win.clearTimeout(controller.transitionTimer);
          controller.transition.removeAttribute('data-active');
          void controller.transition.offsetWidth;
          controller.transition.setAttribute('data-active', 'true');
          controller.transitionTimer = win.setTimeout(function () { controller.transition.removeAttribute('data-active'); controller.transitionTimer = null; }, 1100);
        }
        controller.scene = state.scene;
        controller.buttons.forEach(function (button) {
          attribute(button, 'aria-pressed', String(Number(button.getAttribute('data-fg-go')) === state.scene));
        });
        controller.labels.forEach(function (label) { label.textContent = NAMES[state.scene]; });
      }
    }
    function renderAll() {
      if (disposed || doc.hidden) return;
      controllers.forEach(function (controller) { render(controller); });
    }
    function schedule() {
      if (disposed || doc.hidden || !controllers.size) return;
      if (frame !== null) return;
      frame = win.requestAnimationFrame(function () {
        frame = null;
        renderAll();
      });
    }
    function syncMotion() {
      attribute(html, 'data-fg-reduced', String(reduced()));
      if (reduced()) clearBursts();
      renderAll();
    }
    function findRoots(scope) {
      var roots = [];
      if (scope.matches && scope.matches(ROOT)) roots.push(scope);
      if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(ROOT)));
      return roots;
    }
    function init(scope) {
      if (disposed) return;
      findRoots(scope || doc).forEach(function (root) {
        if (controllers.has(root)) return;
        var stage = root.querySelector('[data-fg-stage]');
        if (!stage) return;
        var controller = {
          root: root,
          stage: stage,
          rooms: Array.from(root.querySelectorAll('[data-fg-room]')),
          buttons: Array.from(root.querySelectorAll('[data-fg-go]')),
          labels: Array.from(root.querySelectorAll('[data-fg-scene-name]')),
          burst: root.querySelector('[data-fg-burst]'),
          transition: root.querySelector('[data-fg-bloom-transition]'),
          transitionTimer: null,
          scene: -1,
          lastBurst: -Infinity
        };
        controllers.set(root, controller);
        attribute(root, 'data-fg-ready', 'true');
        if (!doc.hidden) render(controller);
      });
      attribute(html, 'data-fg-reduced', String(reduced()));
    }
    function destroy(controller) {
      clearBursts(controller);
      if (controller.transitionTimer) win.clearTimeout(controller.transitionTimer);
      if (controller.transition) controller.transition.removeAttribute('data-active');
      controllers.delete(controller.root);
      controller.root.removeAttribute('data-fg-ready');
      controller.root.removeAttribute('data-scene');
      controller.stage.removeAttribute('data-scene');
      ['--fg-progress', '--fg-travel', '--fg-bloom', '--fg-world-x', '--fg-world-y', '--fg-story-drift', '--fg-light-drift'].forEach(function (name) { controller.stage.style.removeProperty(name); });
      controller.rooms.forEach(function (room) {
        room.style.removeProperty('--fg-opacity');
        room.style.removeProperty('--fg-room-scale');
      });
      if (!controllers.size) cancelFrame();
    }
    function eventController(target) {
      var root = target && target.closest ? target.closest(ROOT) : null;
      return root ? controllers.get(root) : null;
    }
    function click(event) {
      var target = event.target && event.target.closest ? event.target.closest('button, [data-fg-go], [data-fg-open]') : null;
      if (!target || target.disabled || target.hasAttribute('disabled') || event.isTrusted === false || target.hasAttribute('data-fg-motion') || target.hasAttribute('data-fg-close')) return;
      var controller = eventController(target);
      if (!controller) return;
      var detail = { source: 'action-click' };
      if (event.detail !== 0 && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) {
        detail.clientX = event.clientX; detail.clientY = event.clientY;
      } else {
        var anchor = target.getBoundingClientRect();
        detail.clientX = finite(anchor.left, 0) + finite(anchor.width, 0) / 2;
        detail.clientY = finite(anchor.top, 0) + finite(anchor.height, 0) / 2;
      }
      burst({ target: target, detail: detail });
      if (!target.hasAttribute('data-fg-go')) return;
      var index = Number(target.getAttribute('data-fg-go'));
      if (!Number.isInteger(index) || index < 0 || index > 3) return;
      event.preventDefault();
      var root = controller.root;
      win.scrollTo({
        top: sceneScrollTarget(root.getBoundingClientRect().top, root.offsetHeight, win.innerHeight, win.scrollY, index),
        behavior: reduced() ? 'instant' : 'smooth'
      });
    }
    function burst(event) {
      if (reduced() || doc.hidden || disposed || petalCount >= MAX_PETALS) return;
      var controller = eventController(event.target);
      if (!controller && event.target === doc && controllers.size === 1) controller = controllers.values().next().value;
      if (!controller || !controller.burst) return;
      var detail = event.detail || {};
      if (!['confirmed-editor', 'action-click', 'personalization'].includes(detail.source)) return;
      var dialog = controller.root.querySelector('dialog[open]');
      var explicitAction = detail.source === 'action-click' || detail.source === 'personalization';
      if ((dialog || controller.root.getAttribute('data-fg-dialog') === 'true') && !explicitAction) return;
      if (doc.querySelector('dialog[open]') && !dialog) return;
      var now = win.performance && win.performance.now ? win.performance.now() : Date.now();
      if (now - controller.lastBurst < ACTION_COOLDOWN) return;
      controller.lastBurst = now;
      var host = dialog || controller.stage;
      var rect = host.getBoundingClientRect();
      var width = Math.max(0, finite(rect.width, 0));
      var height = Math.max(0, finite(rect.height, 0));
      var x = Number.isFinite(detail.clientX) ? detail.clientX - finite(rect.left, 0) : width * 0.5;
      var y = Number.isFinite(detail.clientY) ? detail.clientY - finite(rect.top, 0) : height * 0.55;
      if (dialog && !dialog.contains(event.target)) {
        x = width * .5; y = Math.min(height * .2, 95);
      }
      var group = { controller: controller, nodes: [], timer: null, overlay: null };
      var overlay = controller.burst;
      if (dialog) {
        overlay = doc.createElement('div'); overlay.className = 'fg-action-burst';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.style.height = Math.max(height, finite(dialog.scrollHeight, height)) + 'px';
        dialog.appendChild(overlay); group.overlay = overlay;
        y += finite(dialog.scrollTop, 0); x += finite(dialog.scrollLeft, 0);
      }
      var count = Math.min(BURST_SIZE, MAX_PETALS - petalCount);
      for (var index = 0; index < count; index += 1) {
        var petal = doc.createElement('span');
        var angle = index / count * Math.PI * 2;
        var radius = 32 + index % 3 * 11;
        petal.className = 'fg-petal fg-action-flower';
        petal.textContent = '✿';
        petal.setAttribute('aria-hidden', 'true');
        petal.style.setProperty('--fg-petal-color', ['#a5756c', '#b69554', '#8f7d68'][index % 3]);
        petal.style.left = clamp(x, 0, width).toFixed(1) + 'px';
        petal.style.top = clamp(y, 0, dialog ? Math.max(height, finite(dialog.scrollHeight, height)) : height).toFixed(1) + 'px';
        petal.style.setProperty('--fg-x', (Math.cos(angle) * radius).toFixed(1) + 'px');
        petal.style.setProperty('--fg-y', (Math.sin(angle) * radius - 30).toFixed(1) + 'px');
        petal.style.setProperty('--fg-rotation', (index % 2 ? 24 : -24) + 'deg');
        petal.style.setProperty('--fg-duration', '750ms');
        overlay.appendChild(petal);
        group.nodes.push(petal);
      }
      petalCount += group.nodes.length;
      bursts.add(group);
      group.timer = win.setTimeout(function () { removeBurst(group); }, PETAL_LIFETIME);
    }
    function section(event, unload) {
      var target = event.target;
      var ancestor = target && target.closest ? target.closest(ROOT) : null;
      Array.from(controllers.values()).forEach(function (controller) {
        if (controller.root === target || (target.contains && target.contains(controller.root)) || controller.root.contains(target)) destroy(controller);
      });
      if (!unload) init(ancestor || target);
    }
    function dispose() {
      if (disposed) return;
      disposed = true;
      cancelFrame();
      Array.from(controllers.values()).forEach(destroy);
      clearBursts();
      removers.splice(0).forEach(function (remove) { remove(); });
      if (priorReduced === null) html.removeAttribute('data-fg-reduced');
      else html.setAttribute('data-fg-reduced', priorReduced);
    }

    listen(win, 'scroll', schedule, { passive: true });
    listen(win, 'resize', schedule, { passive: true });
    listen(doc, 'click', click);
    listen(doc, 'fas:selection', burst);
    listen(doc, 'fas:flower', burst);
    listen(doc, 'shopify:section:load', function (event) { section(event, false); });
    listen(doc, 'shopify:section:unload', function (event) { section(event, true); });
    listen(doc, 'visibilitychange', function () {
      if (doc.hidden) { cancelFrame(); clearBursts(); }
      else renderAll();
    });
    if (query) {
      if (query.addEventListener) listen(query, 'change', syncMotion);
      else if (query.addListener) {
        query.addListener(syncMotion);
        removers.push(function () { query.removeListener(syncMotion); });
      }
    }
    if (doc.readyState === 'loading') listen(doc, 'DOMContentLoaded', function () { init(doc); });
    else init(doc);
    return { init: init, dispose: dispose };
  }

  return {
    gardenState: gardenState,
    scrollRange: scrollRange,
    sceneScrollTarget: sceneScrollTarget,
    roomState: roomState,
    experienceState: experienceState,
    effectiveReduced: effectiveReduced,
    createEngine: createEngine
  };
}));
